/**
 * Copyright (c) 2021 BlockDev AG
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { FC } from 'react';
import { Col } from 'react-bootstrap';
import styles from './DashboardTile.module.scss';

type Props = {
    title: string;
    value: number;
    icon: string;
};

export const DashboardTile: FC<Props> = ({ title, value, icon }) => {
    return (
        <Col className={styles.wrapper}>
            <div className={styles.icon}>
                <img src={`/assets/img/${icon}`} alt={title} />
            </div>
            <div className={styles.title}>{title}</div>
            <div className={styles.value}>{value.toFixed(3)}</div>
            <div className={styles.currency}>MYST</div>
        </Col>
    );
};
